export default function Loading() {
  return (
    <div className="progress fixed-top" style={{ top: 0, height: 5, borderRadius: 0 }}>
      <div
        className="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        style={{ width: "100%", backgroundColor: "var(--g2-light-blue)" }}
      ></div>
    </div>
  );
}
